(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

  class Footer extends HTMLElement {
    constructor() {
      super();
      this.mql = window.matchMedia('(max-width: 749px)');
    }
    connectedCallback() {
      if (this.mql.matches) {
        console.log('matches')
        const newsletter = document.querySelector('.footer-block__newsletter');
        const blocksWrapper = document.querySelector('.footer__blocks-wrapper');
        if (newsletter && blocksWrapper) {
          blocksWrapper.appendChild(newsletter);
        }
      }
    }
  }

  customElements.define('footer-element', Footer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        document.body.classList.contains('template--index');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.mainMegaMenuItems = this.querySelectorAll('details.mega-menu');

      this.body = document.querySelector('body');

      this.addEventListener('mouseover', () => {
        this.body.classList.add('header-hovered');
      });

      this.addEventListener('mouseout', () => {
        this.body.classList.remove('header-hovered');
      });

      this.mainMegaMenuItems.forEach((item) => {
        item.addEventListener('mouseover', () => {
          this.openedMegaMenu(item);
        });
        item.addEventListener('mouseout', () => {
          this.closeMegaMenu(item);
        });
      });

      this.createObserver();
    }

    openedMegaMenu(item) {
      this.mainMegaMenuItems.forEach((item) => {
        item.removeAttribute('open');
      });
      this.body.classList.add('header-mega-menu-opened');
      item.setAttribute('open', '');
    }

    closeMegaMenu(item) {
      setTimeout(() => {
        if (item.matches(':hover') || item.closest('header').matches(':hover')) return;
        item.removeAttribute('open');
        this.body.classList.remove('header-mega-menu-opened');
      }, 300);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (window.matchMedia('(max-width: 749px)')) {
        document.documentElement.style.setProperty('--header-mobile-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closest('body').classList.add('header-sticky', 'header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.closest('body').classList.remove('header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closest('body').classList.remove('header-sticky', 'header-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
